module.exports = __webpack_public_path__ + "img/logo.62c28519.svg";